import { closeFeedback } from "./active-feedback-session";
export function FeedbackAccessNotice({
  state,
}: {
  readonly state:
    | { readonly kind: "loading" }
    | {
        readonly kind: "error";
        readonly message: string;
        readonly onRetry: () => void;
      }
    | { readonly kind: "forbidden" };
}) {
  if (state.kind === "error") {
    return (
      <div className="fixed bottom-4 left-4 z-[85] w-[min(360px,calc(100vw-32px))] rounded-3xl border border-[#b25c3b]/20 bg-[rgba(255,243,236,0.98)] p-4 text-sm text-[#b25c3b] shadow-[0_22px_50px_rgba(14,39,88,0.16)]">
        <div className="flex items-start justify-between gap-3">
          <p>{state.message}</p>
          <div className="flex gap-3">
            <button
              type="button"
              onClick={state.onRetry}
              className="text-xs font-semibold uppercase"
            >
              Retry
            </button>
            <button
              type="button"
              onClick={closeFeedback}
              className="text-xs font-semibold uppercase"
            >
              Exit
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (state.kind === "loading") {
    return (
      <div className="fixed bottom-4 left-4 z-[85] w-[min(320px,calc(100vw-32px))] rounded-3xl border border-[#0e2758]/10 bg-[rgba(255,253,244,0.98)] p-4 text-sm text-[#4a5f8c] shadow-[0_22px_50px_rgba(14,39,88,0.16)]">
        Loading…
      </div>
    );
  }

  {
    return (
      <div className="fixed bottom-4 left-4 z-[85] w-[min(360px,calc(100vw-32px))] rounded-3xl border border-[#0e2758]/10 bg-[rgba(255,253,244,0.98)] p-4 shadow-[0_22px_50px_rgba(14,39,88,0.16)]">
        <div className="flex items-start justify-between gap-3">
          <div>
            <p className="mt-2 text-sm font-semibold text-[#0e2758]">
              Softmax team access required
            </p>
            <p className="mt-2 text-sm text-[#6b7ea6]">
              This session is active, but feedback tools are unavailable for
              this account.
            </p>
          </div>
          <button
            type="button"
            onClick={closeFeedback}
            className="text-xs font-semibold tracking-[0.08em] text-[#4a5f8c] uppercase"
          >
            Exit
          </button>
        </div>
      </div>
    );
  }
}
